export var TASK_TYPE = /* @__PURE__ */ ((TASK_TYPE2) => {
  TASK_TYPE2["REQUEST_DEFER"] = "request_defer";
  TASK_TYPE2["OPT_IN_FLOW"] = "opt_in_flow";
  TASK_TYPE2["SCHEDULE_MESSAGE"] = "send_merchant_sms";
  TASK_TYPE2["SEND_OUTBOUND_MESSAGE"] = "send_outbound_message";
  TASK_TYPE2["SEND_MESSAGE_NO_REPLY"] = "send_merchant_sms_no_reply";
  TASK_TYPE2["SEND_MESSAGE_DELIVER_ASSUME"] = "send_merchant_sms_deliver_assume";
  TASK_TYPE2["UPDATE_OUTBOUND_MESSAGE"] = "update_outbound_message";
  TASK_TYPE2["SEND_ORDER_NO_PURCHASE"] = "send_order_no_purchase";
  TASK_TYPE2["PROPAGATE_MARKETING_PERMISSION"] = "propagate_marketing_permission";
  TASK_TYPE2["PROPAGATE_EMAIL_MARKETING_CONSENT"] = "propagate_email_marketing_consent";
  TASK_TYPE2["CART_CONCIERGE"] = "cart_concierge";
  TASK_TYPE2["CHECKOUT_ENQUEUE"] = "checkout_enqueue";
  TASK_TYPE2["CHECKOUT_PENDING_FINALIZE"] = "checkout_finalize";
  TASK_TYPE2["CHECKOUT_LINK_REMINDER"] = "checkout_link_reminder";
  TASK_TYPE2["CHECKOUT_REFUND"] = "checkout_refund";
  TASK_TYPE2["CHECKOUT_CAPTURE"] = "checkout_capture";
  TASK_TYPE2["UPDATE_ORDER_METADATA"] = "update_order_metadata";
  TASK_TYPE2["APPLY_MERCHANT_PLATFORM_FEE"] = "apply_merchant_platform_fee";
  TASK_TYPE2["SUBSCRIPTION_REFILL_QUEUE"] = "subscription_refill_queue";
  TASK_TYPE2["SUBSCRIPTION_REFILL"] = "subscription_refill";
  TASK_TYPE2["SUBSCRIPTION_SEND_OFFER"] = "subscription_send_offer";
  TASK_TYPE2["AUTHORIZATION_VOID"] = "authorization_void";
  TASK_TYPE2["PURCHASE_OFFER_UPSELL_NO_REPLY"] = "purchase_offer_upsell_no_reply";
  TASK_TYPE2["INITIALIZE_CAMPAIGN"] = "initialize_group_flow";
  TASK_TYPE2["INITIALIZE_CUSTOM_FLOW_INSTANCE"] = "initialize_flow";
  TASK_TYPE2["EXECUTE_CORE_FLOW"] = "execute_core_flow";
  TASK_TYPE2["EXECUTE_CUSTOM_FLOW_STEP"] = "execute_flow_step";
  TASK_TYPE2["ON_CAMPAIGN_LAUNCH"] = "on_campaign_launch";
  TASK_TYPE2["GENERATE_AUTOMATIC_CAMPAIGNS"] = "generate_automatic_campaigns";
  TASK_TYPE2["GENERATE_AUTOMATIC_MERCHANT_CAMPAIGN"] = "generate_automatic_merchant_campaign";
  TASK_TYPE2["VALIDATE_ALL_MERCHANT_AUTOMATIONS"] = "validate_all_merchant_automations";
  TASK_TYPE2["VALIDATE_MERCHANT_AUTOMATIONS"] = "validate_merchant_automations";
  TASK_TYPE2["SYNC_BUILTIN_FLOWS"] = "sync_builtin_flows";
  TASK_TYPE2["TRIGGER_FLOW_EVENT"] = "flow_event";
  TASK_TYPE2["TRIGGER_FLOW_ERROR"] = "trigger_flow_error";
  TASK_TYPE2["EXTERNAL_ORDER_CREATE_EVENT"] = "external_order_confirmation_send";
  TASK_TYPE2["RECOVER_BROWSE"] = "recover_browse";
  TASK_TYPE2["RECOVER_CART_OR_CHECKOUT"] = "recover_order";
  TASK_TYPE2["RECOVER_PRODUCT_VIEW"] = "recover_product_view";
  TASK_TYPE2["RECOVER_ORDER_REMINDER"] = "recover_order_reminder";
  TASK_TYPE2["RECOVER_SHOPIFY_ORDER"] = "recover_shopify_order";
  TASK_TYPE2["RECOVER_WOO_ORDER"] = "recover_woo_order";
  TASK_TYPE2["SYNC_SHOPIFY_PRODUCTS"] = "sync_shopify_products";
  TASK_TYPE2["TRIGGER_ALL_MERCHANT_PRODUCT_SYNC"] = "trigger_merchant_product_sync";
  TASK_TYPE2["MERCHANT_PRODUCT_SYNC"] = "merchant_product_sync";
  TASK_TYPE2["POLL_SHOPIFY_PRODUCT_SYNC_FILE"] = "poll_shopify_product_sync_file";
  TASK_TYPE2["PREORDER_CHECK"] = "preorder_check";
  TASK_TYPE2["AUTO_INSTALL_SDK"] = "auto_install_sdk";
  TASK_TYPE2["AUTO_INSTALL_ALL_SDKS"] = "auto_install_all_sdks";
  TASK_TYPE2["AUTO_SETUP_ALL_WEBHOOKS"] = "auto_setup_all_webhooks";
  TASK_TYPE2["AUTO_SETUP_REDIRECT"] = "auto_setup_redirect";
  TASK_TYPE2["AUTO_SETUP_WEBHOOKS"] = "auto_setup_webhooks";
  TASK_TYPE2["AUTO_FAQ_CRAWL"] = "auto_faq_crawl";
  TASK_TYPE2["INVOICE_ALL_ACCOUNTS"] = "invoice_all_accounts";
  TASK_TYPE2["INVOICE_ACCOUNT"] = "invoice_account";
  TASK_TYPE2["PRECACHE_ALL_MERCHANT_STATS"] = "precache_all_merchant_stats";
  TASK_TYPE2["EXPORT_ALL_MERCHANT_STATS"] = "export_all_merchant_stats";
  TASK_TYPE2["SEND_INVOICE_EMAIL"] = "send_invoice_email";
  TASK_TYPE2["SEND_FLOW_PERFORMANCE_THREAD_MESSAGE"] = "send_flow_performance_thread_message";
  TASK_TYPE2["SEND_FLOW_PERFORMANCE_THREAD_COMMENT"] = "send_flow_performance_thread_comment";
  TASK_TYPE2["INITIALIZE_FLOW_PERFORMANCE_MESSAGES"] = "initialize_flow_performance_messages";
  TASK_TYPE2["DETERMINE_CARRIER_FEES"] = "determine_carrier_fees";
  TASK_TYPE2["APPLY_PLATFORM_FEES"] = "apply_platform_fees";
  TASK_TYPE2["CAMPAIGN_NOTIFICATION"] = "campaign_notification";
  TASK_TYPE2["SYNC_TOLLFREE_PROVISION_STATUS"] = "sync_tollfree_provision_status";
  TASK_TYPE2["MERCHANT_ISSUE_NOTIFICATION"] = "merchant_issue_notification";
  TASK_TYPE2["AUTOMATE_KLAVIYO_SETUP"] = "automate_klaviyo_setup";
  TASK_TYPE2["MARKETING_CONSENT_MIGRATION"] = "marketing_consent_migration";
  TASK_TYPE2["IMPORT_EXTERNAL_SUBSCRIBERS"] = "import_external_subscribers";
  TASK_TYPE2["GENERATE_SUBSCRIBER_CSV"] = "generate_subscriber_csv";
  TASK_TYPE2["POLL_TELNYX_10DLC_BRAND_CREATION"] = "poll_telnyx_10dlc_brand_creation";
  TASK_TYPE2["PROVISION_TELNYX_TOLL_FREE_VERIFICATION_REQUEST"] = "provision_telnyx_toll_free_verification_request";
  TASK_TYPE2["FINANCIAL_REPORT"] = "financial_report";
  TASK_TYPE2["VERIFY_LINKED_ACCOUNT_CREDENTIALS"] = "verify_linked_account_credentials";
  TASK_TYPE2["GITHUB_MANAGEMENT"] = "github_management";
  TASK_TYPE2["LLM_EVALS"] = "llm_evals";
  TASK_TYPE2["LLM_HOURLY_AGGREGATE"] = "llm_hourly_aggregate";
  TASK_TYPE2["FEE_APPLY"] = "fee_apply";
  TASK_TYPE2["NOTIFY_LONG_RUNNING_MONGO_OPS"] = "notify_long_running_mongo_ops";
  TASK_TYPE2["TEST"] = "test";
  TASK_TYPE2["STRESS_TEST"] = "stress_test";
  TASK_TYPE2["SCHEDULE_STRESS_TEST"] = "schedule_stress_test";
  TASK_TYPE2["TEST_SEGMENT_MEMBER_FETCH"] = "test_segment_member_fetch";
  TASK_TYPE2["UPDATE_CUSTOM_FLOW_INSTANCE_STATE"] = "update_custom_flow_instance_state";
  return TASK_TYPE2;
})(TASK_TYPE || {});
export const DEPRECATED_TASK_TYPES = /* @__PURE__ */ new Set([
  "recover_shopify_order" /* RECOVER_SHOPIFY_ORDER */,
  "update_custom_flow_instance_state" /* UPDATE_CUSTOM_FLOW_INSTANCE_STATE */,
  "trigger_flow_error" /* TRIGGER_FLOW_ERROR */,
  "update_outbound_message" /* UPDATE_OUTBOUND_MESSAGE */,
  "determine_carrier_fees" /* DETERMINE_CARRIER_FEES */
]);
export const TEST_TASK_TYPES = [
  "test" /* TEST */
];
export var TASK_STATUS = /* @__PURE__ */ ((TASK_STATUS2) => {
  TASK_STATUS2["SCHEDULED"] = "scheduled";
  TASK_STATUS2["CANCELED"] = "canceled";
  TASK_STATUS2["EXECUTING"] = "executing";
  TASK_STATUS2["COMPLETE"] = "complete";
  TASK_STATUS2["ERROR"] = "error";
  return TASK_STATUS2;
})(TASK_STATUS || {});
